import api                from '@/api'
import jsPDF              from 'jspdf';
import fmt                from '@/components/mixins/fmt.js'
export default {
    mixins : [fmt],
    methods: {

    async printCCB_PDF(customerId)
    { 
      
      const sp   = {'sp'             : 'spCustomerCashBackPDF'}
      var data = {'customerId'         : customerId }
      
      const json  = Object.assign(data, sp)
    
      await api.post(json).then(res => {
        if(res.status==200)
          {
            
            const items = res.data.recordsets[0] 
            
            
            if(items.length > 0)
            {
              this.printPDF(items)
            }
            
          }
          else if(res.status==500)
          {
            console.log(res.data)

          } 
          else
          {
            console.log('Network Error.')                  
          } 
      }).catch(err => 
      {
        console.log(err.message)    
      }).finally(() => {
        
      });


    
    },
  
  printPDF(items)
    {
      
      
    
      const doc = new jsPDF()
      const customer = items[0].last_name + ' ' +  items[0].first_name     
      const cashback = items[0].cashback
      var page = 1
      
      var pages = parseInt(items.length / 50) == items.length / 50 ? parseInt(items.length / 50) : parseInt(items.length / 50) + 1
      
      var row_index = 1
      var page_index = 1
      var init_row = 31
      var row = init_row
      var row_header = row -5

      
      const col1 = 15
      const col2 = 35
      const col3 = 60
      const col4 = 200


      const header = (customer,cashback) =>
      {
        
       
        doc.setFontSize(12)
        
        doc.text('OPERAZIONI E SALDO CASHBACK AL ' + this.fmtDate()  ,  105, 10, null, null, "center");
        doc.setTextColor(0, 0, 255);
        doc.text(customer,  105, 15, null, null, "center");
        doc.setTextColor(34, 139, 34);
        doc.text('CASHBACK € ' +   this.fmt1(cashback),  105, 20, null, null, "center");
        doc.setTextColor(0, 0, 0);
                
        doc.setFont("helvetica","bold");
      
        doc.setFontSize(12)
      
        doc.text('DATA', col1,row_header);
        doc.text('SEDE', col2, row_header);
        doc.text('OPERAZIONE', col3, row_header);
        doc.text('IMPORTO', col4 , row_header,null,null,'right');
        doc.setFont("helvetica","normal");

      }
      var footer = function()
      {
        doc.setFontSize(10)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  105, 290, null, null, "center");
       
      }
      header(customer,cashback)
      footer()


      items.forEach(item=>{
               
        doc.setFontSize(10)
                        
        doc.setFont("helvetica","normal");   
        doc.text(item.create_at, col1, row);  
        doc.text(item.store, col2, row);
       
        doc.text(item.type.substr(0,50), col3, row);
        doc.text(this.fmt1(item.cb), col4, row,null,null,'right');
        
        if(page_index == 50 && row_index < this.items.length)
        {
          page++  
          doc.addPage("a4");
          header(customer)
          footer()
          row = init_row
          row_index++
          page_index = 1
        }
        else
        {
          row = row + 5
          row_index++
          page_index++
        }
        
      })

      doc.setFontSize(10)
        
      let fileName = 'CheckList_' + Date.now().toString()      
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      
    },
   

    }
  }
